import { FormEvent } from 'react';
import { FormControl } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useFetchBookingDotComRoomNames from 'components/domain/bookingDotCom/useFetchBookingDotComRoomNames';
import SelectField from 'components/forms/selectField/SelectField';
import { RoomTypes } from 'models/bookingDotCom/RoomTypes';
import { orderBy } from 'utils/arrayUtils';
import { PropertySettingsMainTabFormValues } from '../../PropertySettingsMainTab.schema';

const ROOM_TYPE_ORDER = [
  RoomTypes.APARTMENT,
  RoomTypes.SINGLE,
  RoomTypes.STUDIO,
  RoomTypes.FAMILY,
  RoomTypes.TWIN_DOUBLE,
  RoomTypes.DORMITORY_ROOM,
  RoomTypes.BED_IN_DORMITORY,
  RoomTypes.BUNGALOW,
  RoomTypes.CHALET,
  RoomTypes.HOLIDAY_HOME,
  RoomTypes.VILLA,
  RoomTypes.MOBILE_HOME,
  RoomTypes.TENT,
  RoomTypes.QUADRUPLE,
  RoomTypes.SUITE,
  RoomTypes.TRIPLE,
  RoomTypes.TWIN,
  RoomTypes.DOUBLE,
];

const RoomTypeField = () => {
  const { t } = useTranslation();
  const { uid: propertyUid } = useParams();
  const { setValue } = useFormContext<PropertySettingsMainTabFormValues>();
  const { data: roomNamesData } =
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    useFetchBookingDotComRoomNames({ propertyUid });

  const sortedRoomTypes = orderBy(Object.values(RoomTypes), [
    { field: (roomType) => ROOM_TYPE_ORDER.indexOf(roomType), order: 'asc' },
  ]);

  const roomTypeOptions = sortedRoomTypes.map((value) => ({
    label: t(
      `pageProperty.mainSettings.bookingDotComSettings.roomTypeOptions.${value}`,
    ),
    value,
  }));

  const onChange = (event: FormEvent<FormControl>) => {
    const newRoomType = (event.target as HTMLSelectElement).value;
    const firstMatchingName = (roomNamesData?.availableRoomNames ?? []).find(
      (rn) =>
        rn.typeName &&
        newRoomType &&
        rn.typeName.toLowerCase() === newRoomType.toLowerCase(),
    )?.roomName;
    setValue('bookingDotComSettings.roomName', firstMatchingName ?? '', {
      shouldDirty: true,
    });
  };

  return (
    <SelectField
      label={t('pageProperty.mainSettings.bookingDotComSettings.roomType')}
      name="bookingDotComSettings.roomType"
      options={roomTypeOptions}
      onChangeHandler={onChange}
      colSmInput={7}
      colSmLabel={5}
      required
    />
  );
};

export default RoomTypeField;
